import React from "react";

import { TextBox, Button as TextBoxButton } from "devextreme-react/text-box";
import { CheckBox, Tooltip } from "devextreme-react";

import { DateFnsDateUtil } from "@ezhou/common-utils";

import { cleanForCSSIdentifier } from "../utils/cssUtil";

import { FormItemConfig } from "./dataFormModel";

const parseDate = (d: unknown) => {
  if (typeof d === "string") {
    return new Date(d);
  } else {
    return d as Date;
  }
};

export default function DevExtremeDataFormNoEditableFieldTemplate(
  theData: unknown,
  tooltip: string | undefined,
) {
  return function template(data: FormItemConfig) {
    const dateUtil = new DateFnsDateUtil();
    if (data.editorType == "dxDateBox") {
      if (theData) {
        theData = dateUtil.format(parseDate(theData), "MM/dd/yyyy");
      }
    }
    if (typeof theData !== "string") {
      theData = JSON.stringify(theData);
    }

    const elementId = cleanForCSSIdentifier(data.dataField);

    const renderField = () => {
      if (data.editorType == "dxCheckBox") {
        let theCheckboxData = false;
        if (typeof theData === "boolean") {
          theCheckboxData = theData;
        } else if (typeof theData === "string") {
          theCheckboxData = theData.toLowerCase() === "true" ? true : false;
        } else {
          theCheckboxData = theData == true;
        }
        return <CheckBox value={theCheckboxData} disabled={true} readOnly={true}></CheckBox>;
      } else {
        return (
          <TextBox
            value={theData as string}
            // disabled={true}
            readOnly={true}
            stylingMode="filled"
            width="100%"
          >
            <TextBoxButton
              name="lock"
              location="after"
              options={{
                icon: "lock",
                stylingMode: "text",
              }}
            />
          </TextBox>
        );
      }
    };

    return (
      <React.Fragment>
        <div id={elementId}>{renderField()}</div>
        <Tooltip
          target={"#" + elementId}
          showEvent="mouseenter focusin"
          hideEvent="mouseleave focusout"
        >
          <div id={elementId + "-tooltip-content"}>
            {tooltip ? tooltip : "Reason not specified"}
          </div>
        </Tooltip>
      </React.Fragment>
    );
  };
}
